import { useState, useEffect } from "react";
import { Row, Col, Drawer } from "antd";
import ContainerNoWidth from "../../common/ContainerNoWidth";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";

const Header = () => {
  const [visible, setVisibility] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      const element = document.getElementById(id) as HTMLDivElement;
      element.scrollIntoView({
        behavior: "smooth",
      });
      setVisibility(false);
    };
    return (
      <>
        <CustomNavLinkSmall onClick={() => scrollTo("about")}>
          <Span>{"About"}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("galerija")}>
          <Span>{"Galerija"}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("predstave")}>
          <Span>{"Predstave"}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("contact")}>
          <Span>
            <Button>{"Contact"}</Button>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection isScrolled={isScrolled}>
      <ContainerNoWidth>
        <Row justify="space-between">
          <div>
            <img
              className="main-logo"
              src="/img/images/logo.png"
              alt="Logo"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              style={{
                marginBottom: "-19px",
                marginTop: "-16px",
                height: "90px",
                cursor: "pointer",
              }}
            />
          </div>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={6}>
                <Menu>
                  <div>
                    <img
                      className="main-logo-open-nav"
                      src="/img/images/logo.png"
                      alt="Logo"
                    />
                  </div>
                </Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </ContainerNoWidth>
    </HeaderSection>
  );
};

export default Header;
